import React from 'react';
import { getLinkWithQueryParams } from '../../utils/getLinkWithQueryParams';

const BrowserLink = ({ children, ...props }) => {
  return (
    <a {...props} href={getLinkWithQueryParams(props.href)}>
      {children}
    </a>
  );
};

export default BrowserLink;
